
/*
    Hubspot Integration Functions
    See: https://developers.hubspot.com/docs/api/conversation/chat-widget-sdk
*/


export async function loadHubSpotTracker() {
    if (typeof window.HubSpotConversations !== 'undefined') {
        return Promise.resolve();
    }
    return new Promise((resolve, reject) => {
        let d = document;
        let load = function () {
            let s = d.createElement('script');
            s.type = 'text/javascript';
            s.async = true;
            s.defer = true;
            s.id = 'hs-script-loader';
            s.src = '//js.hs-scripts.com/22530795.js';
            s.onload = () => {
                resolve();
            };
            let x = d.getElementsByTagName('script')[0];
            x.parentNode.insertBefore(s, x);
        };
        load();
    });
}

export function onConversationReady(callback) {
    // See: https://developers.hubspot.com/docs/api/conversation/chat-widget-sdk
    if (window.HubSpotConversations) {
        callback?.();
    } else {
        window.hsConversationsOnReady = [callback];
    }
}

export function setDefaultConvoSettings() {
    window.hsConversationsSettings = {
        loadImmediately: false,
        enableWidgetCookieBanner: true,
        disableAttachment: false
    };
}

export function identify(identityObj) {
    // See: https://developers.hubspot.com/docs/api/events/tracking-code?_ga=2.170775968.1098718219.1676326827-374701859.1673390113
    let _hsq = window._hsq = window._hsq || [];
    if (identityObj instanceof Array) {
        identityObj.forEach((iden) => {
            _hsq.push(["identify", iden]);
        });
    }
    else {
        _hsq.push(["identify", identityObj]);
    }   
}